const thumbSwiper = new Swiper(".thumbs-container", {
    spaceBetween: 15,
    slidesPerView: 6,
    breakpoints: {
      768: {
        touchRatio: 0,
        spaceBetween: 8
      }
    },
    navigation: {
      nextEl: ".gallery.swiper-button-next",
      prevEl: ".gallery.swiper-button-prev"
    }
  }),
  mainSwiper = new Swiper(".main-container", {
    slidesPerView: 1,
    autoHeight: !0,
    loop: !0,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets"
    },
    thumbs: {
      swiper: thumbSwiper
    },
    navigation: {
      nextEl: ".mainimg.swiper-button-next",
      prevEl: ".mainimg.swiper-button-prev"
    }
  });
refreshFsLightbox();